import { SectionReviewState, SectionValueView, UserInfo } from "generated/graphql";
import { ReactNode } from "react";
import { useAppSelector } from "redux/hooks";
import { selectUsers } from "redux/slices/client";
import { selectMyUserId } from "redux/slices/session";

export function SectionValueAssignment({
  sectionValue,
  children,
}: {
  sectionValue: SectionValueView;
  children: (body: {
    userIsQAAssignee: boolean;
    userIsReviewAssignee: boolean;
    userIsOverallAssignee: boolean;
    showQAInfo: boolean;
    assignee?: UserInfo;
    qaAssignee?: UserInfo;
    outcomeAssignee?: UserInfo;
  }) => ReactNode;
}) {
  const users = useAppSelector(selectUsers);
  const myUserId = useAppSelector(selectMyUserId);
  const showQAInfo = sectionValue.reviewState === SectionReviewState.Validation;
  const outcomeAssignee = sectionValue.outcomeAssignee
    ? users.find((u) => u.id === sectionValue.outcomeAssignee)
    : undefined;
  const qaAssignee = sectionValue.validationAssignee
    ? users.find((u) => u.id === sectionValue.validationAssignee)
    : undefined;
  const userIsQAAssignee = qaAssignee?.id === myUserId;
  const userIsReviewAssignee = outcomeAssignee?.id === myUserId;
  const userIsOverallAssignee = showQAInfo ? userIsQAAssignee : userIsReviewAssignee;
  const assignee = showQAInfo ? qaAssignee : outcomeAssignee;

  return children({
    userIsOverallAssignee,
    userIsQAAssignee,
    userIsReviewAssignee,
    showQAInfo,
    assignee,
    qaAssignee,
    outcomeAssignee,
  });
}
